import ProductsShopify from './ProductsShopify'

export default ProductsShopify
